import type { WeeklySummaryRow } from '../api/types';

/**
 * Ključevi koje `apps/api/src/scheduled.ts` upisuje u `highlightsJson`.
 * Server šalje samo ključ; rečenicu bira klijent, iz rječnika, na svom jeziku.
 */
export const HIGHLIGHT_KEYS = ['all_workouts_done', 'weight_down', 'steps_goal'] as const;
export type HighlightKey = (typeof HIGHLIGHT_KEYS)[number];

const HIGHLIGHT_MESSAGE: Record<HighlightKey, string> = {
  all_workouts_done: 'summary.highlightAllWorkouts',
  weight_down: 'summary.highlightWeightDown',
  steps_goal: 'summary.highlightSteps',
};

/**
 * Prijevodni ključ za istaknuto. Nepoznat ključ vraća `null` — novi highlight
 * sa servera radije nestane nego da se prikaže kao sirovi `steps_goal`.
 */
export function highlightMessageKey(key: string): string | null {
  return HIGHLIGHT_MESSAGE[key as HighlightKey] ?? null;
}

/** Razlika težine kroz tjedan; `null` kad nema obje mjere. */
export function weightDelta(row: Pick<WeeklySummaryRow, 'weightStart' | 'weightEnd'>): number | null {
  if (row.weightStart === null || row.weightEnd === null) return null;
  return Math.round((row.weightEnd - row.weightStart) * 10) / 10;
}

/** Tjedan bez ijednog traga; server ga ne generira, ali klijent ne smije pasti ako stigne. */
export function isBlankWeek(row: WeeklySummaryRow): boolean {
  return (
    row.workoutsCompleted === 0 &&
    row.workoutsPrescribed === 0 &&
    !row.steps &&
    row.weightStart === null &&
    row.weightEnd === null
  );
}
